import { TAX_IVA_DDJJ_AFIP_ITEM } from './tax-iva-ddjj-mis-comprobantes.js'
import { TAX_IVA_DDJJ_PORTAL_ITEM } from './tax-iva-ddjj-portal.js'
import { TAX_IVA_DDJJ_VENTAS_ITEM } from './tax-iva-ddjj-libro-ventas.js'
import { TAX_IVA_DDJJ_COMPRAS_ITEM } from './tax-iva-ddjj-libro-compras.js'
import { TAX_IVA_DDJJ_LIQUIDACION_ITEM } from './tax-iva-ddjj-liquidacion.js'
import { TAX_IVA_PLAZO_ITEM } from './tax-iva-plazo.js'

/** @type {import('../help-index.js').HelpScreen} */
export const TAX_IVA_HELP = {
  screenId: 'tax-iva',
  label: 'IVA',
  navPath: 'Impuestos → IVA',
  keywords: [
    'iva', 'ddjj', 'libro iva', 'débito fiscal', 'crédito fiscal', 'portal iva',
    'mis comprobantes', 'liquidación iva', 'plazo',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'DDJJ de IVA: conciliación AFIP, export portal, libros ventas/compras, liquidación del período y extensiones de plazo.',
  sidebarItems: [
    TAX_IVA_DDJJ_AFIP_ITEM,
    TAX_IVA_DDJJ_PORTAL_ITEM,
    TAX_IVA_DDJJ_VENTAS_ITEM,
    TAX_IVA_DDJJ_COMPRAS_ITEM,
    TAX_IVA_DDJJ_LIQUIDACION_ITEM,
    TAX_IVA_PLAZO_ITEM,
  ],
}
